import { universalTypeFilterId } from '../../constants/filters';
import { ProductKeys } from '../../constants/product-keys';
import { serveWebPagesInTypeFilter } from '../experiments';

// The universal Type filter represents Atlas app selection (and, when serveWebPagesInTypeFilter
// is on, the web-crawler app) instead of a control the user can see, so a selection there must
// not count towards any selected-filter total.
export const isFilterSelectionCountable = (
	filterId: string,
	selectedProducts: string[],
): boolean => {
	if (filterId !== universalTypeFilterId) {
		return true;
	}

	if (serveWebPagesInTypeFilter()) {
		return (
			!selectedProducts.includes(ProductKeys.Atlas) &&
			!selectedProducts.includes(ProductKeys.AtlassianWebCrawler)
		);
	}

	return !selectedProducts.includes(ProductKeys.Atlas);
};
